import { useCallback, useState } from 'react'
import { RootState } from '../app/store'
import { useAppSelector } from '../app/typedReduxHooks'
import { useFeatureToggle } from '../common/utils/feature-toggle/useFeatureToggle'

export const useSubscriptionGuard = () => {
  const [isSubscriptionNotificationOpen, setIsSubscriptionNotificationOpen] = useState(false)
  const { isFeatureEnabled: isOrgRegistrationAndPaymentFeatureOn } = useFeatureToggle(
    'ORG_REGISTRATION_AND_PAYMENT'
  )
  const { error: subscriptionError, status: subscriptionStatus } = useAppSelector(
    (state: RootState) => state.billing?.subscription
  )
  const isSubscriptionInvalid =
    isOrgRegistrationAndPaymentFeatureOn && (subscriptionStatus !== 'ready' || !!subscriptionError)

  const openSubscriptionNotification = useCallback(() => {
    setIsSubscriptionNotificationOpen(true)
  }, [])

  const closeSubscriptionNotification = useCallback(() => {
    setIsSubscriptionNotificationOpen(false)
  }, [])

  const runWithValidSubscription = useCallback(
    (action: () => void) => {
      if (isSubscriptionInvalid) {
        openSubscriptionNotification()
        return
      }
      action()
    },
    [isSubscriptionInvalid, openSubscriptionNotification]
  )

  return {
    isOrgRegistrationAndPaymentFeatureOn,
    isSubscriptionInvalid,
    isSubscriptionNotificationOpen,
    openSubscriptionNotification,
    closeSubscriptionNotification,
    runWithValidSubscription,
  }
}
